import React from 'react'
import ContactForm from './ContactForm'
import { StaticImage } from "gatsby-plugin-image"

const ContactSection = () => {
    return (
        <>
 {/*     <div className="info-bg">
        <StaticImage
        src="../assets/images/info-bg.svg"
        alt="info-background"
        className="info-img"
        placeholder="tracedSVG"
        
      />  */}
        <div className="contact-page contact-section">
            <ContactForm />
        </div>
        
        </>
    )
}

export default ContactSection
